<template>
    <div>
      <BulletinBoard
        :isProd="isProd"
        :api="api"
        :additionalParam="additionalParam"
        ref="optList"
      >
      </BulletinBoard>
    </div>
    
  </template>
  
  <script>
  import { applyReactInVue } from 'vuereact-combined'
  import { PatientCase } from '@jdh/content-pc-components';

  import { health_pcs_cat_options, health_pcs_drug_list, health_pcs_sku_list, health_pcs_pet_list, health_pcs_child_list } from '../../../../../api/patientCase';
//   const env = import.meta.env.VITE_ENV
  
  export default {
    components: {
      BulletinBoard: applyReactInVue(PatientCase)
    },
    props: [],
    name: 'patientCase',
    data() {
      return {
        tenantCode: localStorage.getItem('saas_partnerId'),
        // isProd: env === 'prod'
        isProd: true,
        api:{
            health_pcs_cat_options, health_pcs_drug_list, health_pcs_sku_list, health_pcs_pet_list, health_pcs_child_list 
        },
        additionalParam:{
          inputRouter:window.location.origin+"/patientCase/import"+window.location.search,
          outputRouter:window.location.origin+"/patientCase/export"+window.location.search,
          deleteRouter:window.location.origin+"/patientCase/delete"+window.location.search,
          goUrl:window.location.origin+"/patientCaseDetail"+window.location.search+'&',
        }
      }
    },
    mounted() { 
      console.log("==== ?",optList)
      // console.log('#bulletin', this.patientId, this.patientPin, this.userCode)
    },
    updated() {
      // console.log('#bulletin updated:', this.patientId, this.patientPin, this.userCode)
    },
  
    methods: {
  
    }
  }
  </script>
  
  <style lang="scss">
  </style>